import { Button } from '@material-ui/core'
import {
    confirmResetPassword, resetPassword, signIn 
} from 'aws-amplify/auth'
import React from 'react'
import validator from 'validator'

import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionSubTitle } from '../../components/atoms/SectionTittle'
import { TextInputEx } from '../../components/atoms/TextInputEx'
import { containerStyles } from '../../styles/ContainerStyles'
import { invoke } from '../../utils/helper'
import { showMessage } from '../../utils/notification'

export const ForgotPassword: React.FC = () => {

    const [email, setEmail] = React.useState('')
    const [emailSent, setEmailSent] = React.useState<boolean>(false)

    const [confirmationCode, setConfirmationCode] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [confirmPassword, setConfirmPassword] = React.useState('')

    const styles = containerStyles()
    const submit = () => {
        invoke(async () => {
            try {
                if (!validator.isEmail(email)) {
                    showMessage('E-mail er ikke ugyldig', 'error')
                }

                if (!emailSent) {
                    await resetPassword({ username: email })
                    setEmailSent(true)
                } else {
                    if (confirmationCode.length !== 6) {
                        showMessage('Bekræftelseskoden skal være på 6 tegn.', 'error')
                    }
                    if (password.length < 6 || confirmPassword.length < 6) {
                        showMessage('Adgangskoden skal være på mindst 6 tegn.', 'error')
                    }
                    if (password !== confirmPassword) {
                        showMessage('Adgangskoder stemmer ikke overens, prøv igen', 'error')
                    }

                    await confirmResetPassword({ username: email, confirmationCode, newPassword: password })
                    await signIn({ username: email, password })
                }
            } finally {
                //
            }
        }, {

            operation: 'Nulstilling af adgangskode',
            showSuccess: true

        }).then()
    }

    return (
        <PageWrapper>
            <div className={styles.auth1Container}>
                <div className={styles.innerAuthContainer}>
                    <SectionSubTitle text="Glemt kodeord?"/>

                    <div className={styles.loginInputs}>
                        {!emailSent && (
                            <div className={styles.forgotPass}>

                                <p style={{ textAlign: 'center', color: 'white' }}>
                                    Ingen problemer! Indtast din registrerede e-mail nedenfor,
                                    så sender vi dig yderligere instruktioner.
                                </p>
                                <TextInputEx
                                    error={!validator.isEmail(email)}
                                    fullWidth
                                    label="Indtast din e-mail"
                                    onChange={setEmail}
                                    value={email}/>
                            </div>
                        )}

                        {emailSent && (
                            <div className={styles.loginInputs}>
                                <TextInputEx
                                    fullWidth
                                    label="Indtast din bekræftelseskode"
                                    onChange={setConfirmationCode}
                                    value={confirmationCode}/>

                                <TextInputEx
                                    fullWidth
                                    type="password"
                                    label="Indtast din nye adgangskode"
                                    onChange={setPassword}
                                    value={password}/>

                                <TextInputEx
                                    fullWidth
                                    type="password"
                                    label="Bekræft ny adgangskode"
                                    onChange={setConfirmPassword}
                                    value={confirmPassword}/>
                            </div>
                        )}

                    </div>
                    <Button
                        disabled={!validator.isEmail(email)}
                        className="btn-auth"
                        onClick={submit}>
                        {emailSent ? 'Nulstil' : 'Send Email'}
                    </Button>
                </div>
            </div>

        </PageWrapper>

    )
}
